"use client";

import * as React from "react";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { Badge } from "components/ui/badge";
import { X } from "lucide-react";
import { toast } from "components/ui/use-toast";
import { MESSAGES } from "../utils/RegionalMessages";
import { useAddRegionalMutation } from "@/services/regional";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";

export function RegionalModalContent() {
  const [items, setItems] = React.useState<string[]>([]);
  const [inputValue, setInputValue] = React.useState("");
  const { handleModal } = useDialogModal();

  const [addRegional] = useAddRegionalMutation();

  const addRegionalBadge = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      setItems([...items, inputValue.trim()]);
      setInputValue("");
    }
  };

  const removeRegionalBadge = (index: number) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const handleAddRegionalBatch = () => {
    try {
      addRegional(items);
      setItems([]);
      handleModal({ isOpen: false });
      toast(MESSAGES.UPDATE.SUCCESS);
    } catch (error) {
      toast(MESSAGES.UPDATE.ERROR);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <Input
        type="text"
        placeholder="Digite uma regional"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyPress={addRegionalBadge}
      />
      <div className="flex flex-wrap gap-2">
        {items.map((item, index) => (
          <Badge
            key={index}
            variant="secondary"
            className="flex items-center gap-1"
          >
            {item}
            <X
              className="h-3 w-3 cursor-pointer"
              onClick={() => removeRegionalBadge(index)}
            />
          </Badge>
        ))}
      </div>
      <div className="flex justify-end">
        <Button
          onClick={handleAddRegionalBatch}
          className={`rounded-md ${items.length === 0 ? "opacity-50 cursor-not-allowed " : ""}`}
          disabled={items.length === 0}
        >
          Adicionar Regionais
        </Button>
      </div>
    </div>
  );
}
